import VehicleBlockHeader from './VehicleBlockHeader';

export default VehicleBlockHeader;
export { VehicleBlockHeader };
